export default __webpack_public_path__ + "static/media/anxiety_and_meditation.b68390a6.png";